import React, { Component } from "react";
import config from "../../config.json";
import httpService from "../../services/httpService";

class CasovaniKlientaAktualni extends Component {
  state = {};

  componentDidMount = () => {
    this.nahrajCasovani();
  };

  componentDidUpdate = () => {
    const { idpobytu } = this.state;
    if (idpobytu && idpobytu !== this.props.idpobytu) {
      this.nahrajCasovani();
    }
  };

  nahrajCasovani = async () => {
    const { idpobytu } = this.props;
    const casovani = await httpService.post(
      config.apiEndpoint + "casovani/casovaniKlienta.php",
      { idpobytu }
    );
    this.setState({ idpobytu, casovani: casovani.data.casovani, loaded: true });
  };

  render() {
    const { loaded, casovani } = this.state;
    return (
      <React.Fragment>
        {loaded ? (
          <React.Fragment>
            <h4>{casovani && casovani[0] && casovani[0].klient}</h4>
            {casovani && casovani.length > 0 ? (
              <table className="table color-table primary-table">
                <thead>
                  <tr>
                    <th>Datum a čas</th>
                    <th>Místo a procedura</th>
                  </tr>
                </thead>
                <tbody>
                  {casovani.map((c, index) => (
                    <tr
                      key={index}
                      className={
                        c.stav &&
                        (c.stav === "vubec"
                          ? "text-danger"
                          : c.stav === "pozde"
                          ? "text-warning"
                          : c.stav === "vcas"
                          ? "text-success"
                          : null)
                      }
                    >
                      <td>
                        {c.den} - {c.cas_od}
                      </td>
                      <td>
                        {c.pracoviste} {c.mistnost}
                        <br />
                        {c.procedura}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="alert alert-danger">Nic tu není...</div>
            )}
          </React.Fragment>
        ) : (
          "Nahrávám..."
        )}
      </React.Fragment>
    );
  }
}

export default CasovaniKlientaAktualni;
